import React from 'react'
import {StepStatus} from "./Steps";

// Constants ----

const statusClasses: Record<StepStatus, string> = {
  active: `h-[0.95em] w-[0.95em] bg-[#16a34a] rounded-[100%] shadow-[0_0_0_.125em_#16a34a] border-2 border-white`,
  inactive: 'h-[0.95em] w-[0.95em] rounded-[100%] border border-dashed border-gray-400',
  completed: 'h-[0.95em] w-[0.95em] rounded-[100%] bg-gray-200 border border-gray-400',
};

// Types ----

type StatusIndicatorProps = {
  status: StepStatus;
}

// Component ----

function StatusIndicator({status}: StatusIndicatorProps) {
  return <div className={statusClasses[status]}></div>;
}

export {StatusIndicator};